export class CompilerDiagnostic {
    constructor(node, messageText, code, category) {
        this.messageText = messageText;
        this.code = code;
        this.category = category;
        this.file = node.getSourceFile();
        this.start = node.getStart();
        this.length = node.getWidth();
        this.source = 'neo-one';
    }
}

//# sourceMappingURL=CompilerDiagnostic.js.map
